import { HttpClient } from "@angular/common/http";
import { Inject, Injectable } from "@angular/core";
import { NmsDialogService } from "@nms-angular-toolkit/nms-dialog";
import { Observable } from "rxjs";
import { TranslationHelperService } from "../util/translation-helper.service";
import { NMS_STATES, STATE } from "../upgraded-provider/upgraded-providers";

export enum FirstPollingStatus {
    SUCCESS = "SUCCESS",
    FAIL = "FAIL",
    RUNNING = "RUNNING"
}

/**
 * Classe responsável por realizar as requisições disponibilizadas pelo serviço de inventory
 */
@Injectable({
    providedIn: "root"
})
export class DevicePollingVerifierService {

    private readonly baseUrl: string;

    constructor(private readonly http: HttpClient,
                private readonly nmsDialogService: NmsDialogService,
                private readonly translationHelperService: TranslationHelperService,
                @Inject(STATE) private readonly $state: any,
                @Inject(NMS_STATES) private readonly nmsStates: any) {
        this.baseUrl = "/device-management-web";
    }

    public checkFirstPollingStatusForMultipleDevices(
            deviceResourceIds: number[], successCallback: Function, errorCallback?: Function): void {

        this.getFirstPollingStatusForMultipleDevices(deviceResourceIds)
            .subscribe((statusByDevices: { [key: number]: FirstPollingStatus }) => {
                if (this.wereAllDevicesPolledAtLeastOnce(statusByDevices)) {
                    successCallback();
                } else {
                    this.handleError("device.error.firstPollingFailedForMultipleDevice", errorCallback);
                }
            });
    }

    public checkIfFirstPollingHasFinished(deviceResourceId: number): void {
        const redirectOnError = () => this.$state.go(this.nmsStates.manageDevices);

        this.checkFirstPollingStatus(deviceResourceId, () => {}, redirectOnError);
    }

    public checkFirstPollingStatus(deviceResourceId: number, successCallback: Function, errorCallback?: Function): void {
        this.getFirstPollingStatus(deviceResourceId).subscribe((status: FirstPollingStatus) =>  {
            switch (status) {
                case FirstPollingStatus.SUCCESS:
                    successCallback();
                    break;
                case FirstPollingStatus.FAIL:
                    this.handleError("device.error.firstPollingFailed", errorCallback);
                    break;
                case FirstPollingStatus.RUNNING:
                    this.handleError("device.error.firstPollingInProgress", errorCallback);
                    break;
            }
        });
    }

    private handleError(translateKey: string, errorCallback: Function): void {
        const message = this.translationHelperService.translate(translateKey);
        this.nmsDialogService.openDialog({ description: message, acceptLabel: "OK" }).catch(() => {
            if (errorCallback) {
                errorCallback()
            }
        });
    }

    private getFirstPollingStatus(deviceResourceId: number): Observable<FirstPollingStatus> {
        return this.http.get<FirstPollingStatus>(`${this.baseUrl}/firstPollingStatus/${deviceResourceId}`)
    }

    private getFirstPollingStatusForMultipleDevices(deviceResourceIds: number[])
        : Observable<{ [key: number]: FirstPollingStatus }> {
        const url = `${this.baseUrl}/firstPollingStatusForMultipleDevices`;
        return this.http.post<{ [key: number]: FirstPollingStatus }>(url, deviceResourceIds);
    }

    private wereAllDevicesPolledAtLeastOnce(statusByDevices: { [key: number]: FirstPollingStatus }): boolean {
        return Object.values(statusByDevices).every(status => status === FirstPollingStatus.SUCCESS);
    }
}
